import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/Signin-backgorund.png";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

function PasswordReset() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: "",
    message: "",
    color: "success",
    icon: "check",
  });

  const navigate = useNavigate();

  const closeSB = () => setSnackbar({ open: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setSnackbar({
        open: true,
        title: "Error",
        message: "Passwords do not match",
        color: "error",
        icon: "warning",
      });
      return;
    }

    // Password strength validation
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!passwordRegex.test(password)) {
      setSnackbar({
        open: true,
        title: "Error",
        message: "La password deve contenere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un carattere speciale (@$!%*?&#)",
        color: "error",
        icon: "warning",
      });
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/password_reset.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setSnackbar({
          open: true,
          title: "Error",
          message: data.message || "Something went wrong",
          color: "error",
          icon: "warning",
        });
        return;
      }

      setSnackbar({
        open: true,
        title: "Success",
        message: "Password has been reset!",
        color: "success",
        icon: "check",
      });

      navigate("testing/login");
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setSnackbar({
        open: true,
        title: "Error",
        message: error.message || "There was an error submitting the form",
        color: "error",
        icon: "warning",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="New Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Confirm New Password"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="secondary" fullWidth type="submit">
                Reset Password
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        open={snackbar.open}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.message}
        onClose={closeSB}
        close={closeSB}
        bgWhite
      />
    </BasicLayout>
  );
}

export default PasswordReset;
